import { useContext } from 'react';
import { UploadContext } from './provider';

export const useUploadSynonyms = () => useContext(UploadContext);
